'use client'

import { useEffect, useMemo, useState } from 'react'
import { useUserContext } from '@/providers/UserProvider'

/**
 * Hook to get notification count by fetching from the API.
 * Lightweight and read-only; includes simple 30s polling.
 */
export function useNotificationCount() {
  const { user } = useUserContext()
  const [unread, setUnread] = useState(0)
  const [loading, setLoading] = useState(false)

  const fetchCount = async () => {
    if (!user) {
      setUnread(0)
      return
    }
    try {
      setLoading(true)
      const res = await fetch('/api/notifications', { credentials: 'include' })
      if (!res.ok) throw new Error('Failed to load notifications')
      const data = await res.json()
      const list = Array.isArray(data) ? data : (data.docs ?? data.notifications ?? [])
      setUnread(list.filter((n: any) => !n.isRead).length)
    } catch (e) {
      // keep previous count on error
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCount()
    const id = setInterval(fetchCount, 30000)
    return () => clearInterval(id)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id])

  return { unreadCount: user ? unread : 0, loading }
}
